import * as React from "react";
const SocialYoutubeIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 40 40",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M36.66 13.202s-.332-2.362-1.35-3.403c-1.294-1.366-2.744-1.373-3.408-1.452C27.144 8 20.007 8 20.007 8h-.015s-7.137 0-11.894.347c-.664.08-2.114.086-3.407 1.452-1.019 1.041-1.351 3.403-1.351 3.403S3 15.977 3 18.751v2.487c0 2.775.34 5.548.34 5.548s.332 2.364 1.35 3.404c1.294 1.365 2.993 1.322 3.75 1.466C11.16 31.919 20 32 20 32s7.145-.011 11.902-.358c.664-.08 2.114-.087 3.407-1.452 1.019-1.04 1.351-3.404 1.351-3.404s.34-2.773.34-5.548V18.75c0-2.774-.34-5.549-.34-5.549ZM16.49 24.504l-.002-9.633 9.188 4.834-9.186 4.8Z",
  clipRule: "evenodd"
}));
export default SocialYoutubeIcon;